import styled from 'styled-components';

import { Swiper, SwiperSlide } from 'swiper/react';

import PcMainBanner from './images/pc_top_banner.png';
import MbMainBanner from './images/mb_top_banner.png';

export const StyledMainBanner = styled.div`
    background-image: url('${PcMainBanner}');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    background-color: transparent;

    height: 40vw;
    display: flex;
    flex-direction: column;
    justify-content: center;

    color: #ffffff;
    padding-left: 12.5vw;

    .bannerLogo {
        width: 21.3125vw;
        height: 4.0625vw;
    }

    .bannerTitle {
        font-weight: 500;
        font-size: 1.625vw;
        line-height: 2.3531vw;
        margin-bottom: 3vw;
    }

    .DownloadBtnWrapper {
        display: flex;
        gap: 1vw;

        svg:nth-child(1) {
            width: 7.9375vw;
            height: 3vw;
        }

        svg:nth-child(2) {
            width: 8.5vw;
            height: 3vw;
        }
    }

    @media screen and (min-width: 1599px) {
        padding-left: 200px;

        .bannerLogo {
            width: 341px;
            height: 65px;
        }

        .bannerTitle {
            font-size: 26px;
            line-height: 37.65px;
            margin-bottom: 48px;
        }

        .DownloadBtnWrapper {
            gap: 16px;

            svg:nth-child(1) {
                width: 127px;
                height: 48px;
            }

            svg:nth-child(2) {
                width: 136px;
                height: 48px;
            }
        }
    }

    @media (max-width: 767px) {
        background-image: url('${MbMainBanner}');
        height: 177.8646vw;
        padding-left: 0;
        align-items: center;

        .bannerLogo {
            width: 44.4362vw;
            height: 11.9714vw;
        }

        .bannerTitle {
            font-weight: 700;
            font-size: 6.6667vw;
            line-height: 9.6536vw;
            text-align: center;
            margin-bottom: 34.13px;
        }

        .mbDownloadBtn {
            cursor: pointer;
            width: 30.3737vw;
            height: 12.1445vw;
            border-radius: 6.6667vw;
            background: #00a5fa;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 4.444vw;
            font-weight: 700;
            line-height: 6.4362vw;
        }
    }
`;

export const StyledAbout = styled.div`
    p {
        margin: 0;
    }

    padding-top: 5.6875vw;

    .aboutWrapper {
        width: 75vw;
        margin: 0 auto;
    }

    .aboutTitleWrapper {
        display: flex;
        justify-content: space-between;
        margin-bottom: 4.3125vw;

        .logo {
            display: flex;
            align-items: center;
            gap: 1vw;

            p {
                font-weight: 900;
                font-size: 3.25vw;
                line-height: 4.7062vw;
            }

            img {
                margin-top: 1vw;
                width: 15.4106vw;
                height: 2.9375vw;
            }
        }

        .aboutText {
            font-weight: 400;
            text-align: right;
            font-size: 1.125vw;
            line-height: 1.6287vw;
            margin-top: 0.6875vw;
        }
    }

    .videoWrapper {
        width: 75vw;

        video {
            width: 100%;
            height: auto;
            border-radius: 1.5vw;
        }
    }

    @media screen and (min-width: 1599px) {
        padding-top: 91px;

        .aboutWrapper {
            width: 1200px;
        }

        .aboutTitleWrapper {
            margin-bottom: 69px;

            .logo {
                gap: 16px;

                p {
                    font-size: 52px;
                    line-height: 75.3px;
                }

                img {
                    margin-top: 16px;
                    width: 246.57px;
                    height: 47px;
                }
            }

            .aboutText {
                font-size: 18px;
                line-height: 26.06px;
                margin-top: 11px;
            }
        }

        .videoWrapper {
            width: 1200px;

            video {
                border-radius: 24px;
            }
        }
    }

    @media (max-width: 767px) {
        padding-top: 6.6667vw;

        .aboutWrapper {
            width: 88.8893vw;
        }

        .aboutTitleWrapper {
            flex-direction: column;
            margin-bottom: 6.5104vw;

            .logo {
                gap: 3.2552vw;

                p {
                    font-size: 6.6667vw;
                    font-weight: 700;
                    line-height: 9.6536vw;
                }

                img {
                    width: 33.5169vw;
                    height: 6.3893vw;
                    margin-top: 1.3021vw;
                }
            }

            .aboutText {
                font-size: 3.3333vw;
                font-weight: 400;
                line-height: 4.8268vw;
                text-align: left;
                margin-top: 7.0924vw;
            }
        }

        .videoWrapper {
            width: 88.8893vw;

            video {
                border-radius: 6.6667vw;
            }
        }
    }
`;

export const StyledFunction = styled.div<{
    $modalVisible: boolean;
}>`
    overflow-x: hidden;

    p {
        margin: 0;
    }

    padding-top: 4.875vw;

    .functionWrapper {
        width: 75vw;
        margin: 0 auto;
    }

    .functionTitle {
        font-weight: 900;
        font-size: 3.25vw;
        line-height: 4.7062vw;
        margin-bottom: 4.875vw;
    }

    .swiper {
        overflow: visible;
    }

    .navigationWrapper {
        display: flex;
        justify-content: flex-end;
        margin-top: 2.5vw;
        gap: 1.875vw;

        svg {
            cursor: pointer;
            width: 3.125vw;
            height: 3.125vw;
        }
    }

    .functionModal {
        ${(props) =>
            props.$modalVisible === true
                ? 'opacity: 1; visibility: visible; transition: opacity 0.5s ease;'
                : 'opacity: 0; visibility: hidden; transition: opacity 0.5s ease, visibility 0s 0.5s;'}

        background: rgba(0,0,0,0.48);
        backdrop-filter: blur(20px);
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 100;
        overflow: auto;

        .modalOverlayContainer {
            box-sizing: border-box;
            display: flex;
            align-items: center;
            min-height: 100%;
            justify-content: center;
        }

        .modalOverlay {
            width: 88.71%;
            max-width: 1260px;

            margin-inline-start: auto;
            margin-inline-end: auto;
            box-sizing: border-box;

            position: relative;
            z-index: 1;
            display: flex;
            flex-direction: column;

            border-radius: 1.125vw;
            margin-top: 2.5vw;
            margin-bottom: 2.5vw;
        }

        .modalContentContainer {
            background: #ffffff;
            order: 2;
            border-radius: 1.5vw;
            padding-inline: 4.875vw 4vw;
            padding-top: 4.875vw;
            padding-bottom: 4vw;
            margin-top: -4.875vw;
        }

        .modalCloseBtn {
            cursor: pointer;
            position: sticky;
            order: 1;
            display: flex;
            align-self: flex-end;
            justify-content: center;
            align-items: center;
            z-index: 9999;
            margin: 0;
            padding: 0;
            border: 0;
            margin-inline-end: 1.875vw;
            margin-top: 1.875vw;
            top: 1.875vw;

            svg {
                width: 3vw;
                height: 3vw;
            }
        }

        .modalTitle {
            font-weight: 700;
            font-size: 1.625vw;
            line-height: 2.3531vw;
        }

        .modalTxt {
            font-weight: 900;
            margin-top: 1vw;
            font-size: 3.25vw;
            line-height: 4.7062vw;
            margin: 1vw 0 4.875vw 0;
        }

        .modalContent {
            border-radius: 1.5vw;
            background: #f5f5f7;

            p {
                color: #6e6e73;
                font-weight: 700;

                padding: 3vw 3.9375vw;
                font-size: 1.625vw;
                line-height: 2.3531vw;

                span {
                    color: #1e1e1e;
                }
            }

            img {
                width: 100%;
                height: auto;
            }
        }

        .modalContent:not(:last-child) {
            margin-bottom: 1vw;
        }
    }

    @media screen and (min-width: 1599px) {
        padding-top: 78px;

        .functionWrapper {
            width: 1200px;
        }

        .functionTitle {
            font-size: 52px;
            line-height: 75.3px;
            margin-bottom: 78px;
        }

        .navigationWrapper {
            margin-top: 40px;
            gap: 30px;

            svg {
                width: 50px;
                height: 50px;
            }
        }

        .functionModal {
            .modalOverlay {
                border-radius: 18px;
                margin-top: 40px;
                margin-bottom: 40px;
            }

            .modalContentContainer {
                border-radius: 24px;
                padding-inline: 78px 64px;
                padding-top: 78px;
                padding-bottom: 64px;
                margin-top: -78px;
            }

            .modalCloseBtn {
                margin-inline-end: 30px;
                margin-top: 30px;
                top: 30px;

                svg {
                    width: 48px;
                    height: 48px;
                }
            }

            .modalTitle {
                font-size: 26px;
                line-height: 37.65px;
            }

            .modalTxt {
                margin-top: 16px;
                font-size: 52px;
                line-height: 75.3px;
                margin: 16px 0 78px 0;
            }

            .modalContent {
                border-radius: 24px;

                p {
                    padding: 48px 63px;
                    font-size: 26px;
                    line-height: 37.65px;
                }
            }

            .modalContent:not(:last-child) {
                margin-bottom: 16px;
            }
        }
    }

    @media (max-width: 767px) {
        padding-top: 6.6667vw;

        .functionWrapper {
            width: 88.8893vw;
        }

        .functionTitle {
            font-size: 6.6667vw;
            font-weight: 700;
            line-height: 9.6536vw;
            margin-bottom: 6.7539vw;
        }

        .navigationWrapper {
            margin-top: 6.6667vw;
            gap: 4.444vw;

            svg {
                width: 13.3333vw;
                height: 13.3333vw;
            }
        }

        .functionModal {
            .modalOverlay {
                width: 100%;
                min-width: 100%;
                border-radius: 2.3438vw;
                margin-top: 5.2083vw;
                margin-bottom: 5.2083vw;
            }

            .modalContentContainer {
                border-radius: 6.6667vw;
                padding-inline: 5.556vw;
                padding-top: 30vw;
                padding-bottom: 8.3333vw;
                margin-top: -21.6146vw;
            }

            .modalCloseBtn {
                margin-inline-end: 8.3333vw;
                margin-top: 8.3333vw;
                top: 8.3333vw;

                svg {
                    width: 13.3333vw;
                    height: 13.3333vw;
                }
            }

            .modalTitle {
                font-size: 3.8893vw;
                line-height: 5.6315vw;
            }

            .modalTxt {
                margin: 2.1784vw 0 6.6667vw 0;
                font-size: 5vw;
                line-height: 7.2396vw;
            }

            .modalContent {
                border-radius: 6.6667vw;
                overflow: hidden;

                p {
                    padding: 13.3333vw 5.4258vw;
                    font-size: 3.8672vw;
                    line-height: 5.6315vw;
                }

                img {
                    width: auto;
                    height: 173.056vw;
                    position: relative;
                    left: 50%;
                    transform: translateX(-50%);
                }
            }

            .modalContent:not(:last-child) {
                margin-bottom: 2.2227vw;
            }
        }
    }
`;

export const StyledFunctionSwiper = styled(Swiper)`
    width: 76.25vw;

    @media (hover: hover) and (pointer: fine) {
        .swiper-slide:hover {
            transform: scale(1.03);
            transition-timing-function: ease-in;
        }
    }

    @media screen and (min-width: 1599px) {
        width: 1220px;
    }

    @media (max-width: 767px) {
        width: 88.8893vw;
    }
`;

export const StyledFunctionSwiperSlide = styled(SwiperSlide)<{
    $txtColor: string;
}>`
    cursor: pointer;
    transition: transform 0.3s ease-out;
    height: 42.1875vw;

    color: ${(props) => (props.$txtColor === 'black' ? '#000000' : '#ffffff')};

    .functionSlideImg {
        width: 24.1875vw;
        height: 42.1875vw;
    }

    .swiperTxtWrapper {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        padding: 1.875vw 3.125vw 1.875vw 1.875vw;
    }

    .functionSlideTitle {
        font-weight: 700;
        font-size: 1.125vw;
        line-height: 1.6287vw;
        margin-bottom: 0.5vw;
    }

    .functionSlideTxt {
        font-weight: 700;
        font-size: 1.625vw;
        line-height: 2.3531vw;
    }

    .functionSlideTitle.black,
    .functionSlideTxt.black {
        text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1);
    }

    .functionSlideTitle.white,
    .functionSlideTxt.white {
        text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
    }

    svg {
        position: absolute;
        right: 3.125vw;
        bottom: 1.875vw;
        width: 3vw;
        height: 3vw;
    }

    @media screen and (min-width: 1599px) {
        height: 675px;

        .functionSlideImg {
            width: 387px;
            height: 675px;
        }

        .swiperTxtWrapper {
            padding: 30px 50px 30px 30px;
        }

        .functionSlideTitle {
            font-size: 18px;
            line-height: 26.06px;
            margin-bottom: 8px;
        }

        .functionSlideTxt {
            font-size: 26px;
            line-height: 37.65px;
        }

        svg {
            right: 50px;
            bottom: 30px;
            width: 48px;
            height: 48px;
        }
    }

    @media (max-width: 767px) {
        height: 142.5vw;

        .functionSlideImg {
            border-radius: 6.6667vw;
            width: 72.2227vw;
            height: 142.5vw;
        }

        .swiperTxtWrapper {
            padding: 8.3333vw 8.724vw 8.3333vw 4.444vw;
        }

        .functionSlideTitle {
            font-size: 3.8893vw;
            line-height: 5.6315vw;
            margin-bottom: 2.2227vw;
        }

        .functionSlideTxt {
            font-size: 5vw;
            line-height: 7.2396vw;
        }

        svg {
            right: 7.569vw;
            bottom: 4.444vw;

            width: 13.3333vw;
            height: 13.3333vw;
        }
    }
`;

export const StyledPlatform = styled.div`
    margin-top: 3.75vw;
    padding-bottom: 7.3125vw;

    .platformWrapper {
        width: 75vw;
        margin: 0 auto;
        user-select: none;
    }

    .platformTitle {
        font-weight: 900;
        font-size: 3.25vw;
        line-height: 4.7062vw;
        margin: 1.3125vw 0;
    }

    .platformDownload {
        position: relative;
        background: #f5f5f7;

        width: 75vw;
        height: 30.875vw;
        border-radius: 1.5vw;

        img {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 41vw;
            height: 20.5vw;
        }
    }

    .DownloadBtnWrapper {
        display: flex;
        justify-content: flex-end;
        position: relative;
        gap: 1vw;
        top: 26vw;
        right: 1.875vw;

        svg:nth-child(1) {
            width: 7.9375vw;
            height: 3vw;
        }

        svg:nth-child(2) {
            width: 8.5vw;
            height: 3vw;
        }
    }

    @media screen and (min-width: 1599px) {
        margin-top: 60px;
        padding-bottom: 117px;

        .platformWrapper {
            width: 1200px;
        }

        .platformTitle {
            font-size: 52px;
            line-height: 75.3px;
            margin: 21px 0;
        }

        .platformDownload {
            width: 1200px;
            height: 494px;
            border-radius: 24px;

            img {
                width: 656px;
                height: 328px;
            }
        }

        .DownloadBtnWrapper {
            gap: 16px;
            top: 416px;
            right: 30px;

            svg:nth-child(1) {
                width: 127px;
                height: 48px;
            }

            svg:nth-child(2) {
                width: 136px;
                height: 48px;
            }
        }
    }

    @media (max-width: 767px) {
        margin-top: 7.8125vw;
        padding-bottom: 15.2344vw;

        .platformWrapper {
            width: 88.8893vw;
        }

        .platformTitle {
            font-weight: 700;
            font-size: 6.6667vw;
            line-height: 9.6536vw;
            margin: 11.6667vw 0 11.7448vw 0;
        }

        .platformDownload {
            width: 88.8893vw;
            height: 137.2227vw;
            border-radius: 6.6667vw;
            overflow: hidden;

            img {
                width: 147.7773vw;
                height: 73.8893vw;
            }
        }

        .DownloadBtnWrapper {
            gap: 0;
            top: 115vw;
            right: 0;
            justify-content: center;

            svg:nth-child(1) {
                width: 16.5365vw;
                height: 6.25vw;
            }

            svg:nth-child(2) {
                width: 17.7083vw;
                height: 6.25vw;
            }
        }

        .mbDownloadBtn {
            cursor: pointer;
            width: 30.3737vw;
            height: 12.1445vw;
            border-radius: 6.6667vw;
            background: #00a5fa;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 4.444vw;
            font-weight: 700;
            line-height: 6.4362vw;
            color: #ffffff;
        }
    }
`;

export const StyledFooter = styled.footer`
    p {
        margin: 0;
        font-size: 0.8125vw;
        font-weight: 400;
    }

    background: #1e1e1e;
    color: #ffffff;
    display: flex;
    justify-content: center;
    padding: 5.8438vw 0 3vw;

    > div {
        width: 75vw;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
    }

    .footerAd {
        > div {
            display: flex;
            align-items: center;
            gap: 0.5vw;

            svg {
                width: 1.5vw;
                height: 1.5vw;
            }
        }

        > div:nth-child(1),
        > div:nth-child(2) {
            margin-bottom: 0.5vw;
        }

        > p {
            margin-top: 1.7188vw;
        }
    }

    .inquiryBtn {
        width: 19.875vw;
        height: 2.875vw;
        border-radius: 0.625vw;
        border: 0.0625vw solid #ffffff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        padding: 0 0.5vw;

        p {
            font-size: 0.8125vw;
            font-weight: 400;
        }

        > div {
            display: flex;
            align-items: center;
            gap: 0.5vw;
        }

        svg {
            width: 1.5vw;
            height: 1.5vw;
        }
    }

    @media screen and (min-width: 1599px) {
        p {
            font-size: 13px;
        }

        padding: 93.5px 0 48px;

        > div {
            width: 1200px;
        }

        .footerAd {
            > div {
                gap: 8px;

                svg {
                    width: 24px;
                    height: 24px;
                }
            }

            > div:nth-child(1),
            > div:nth-child(2) {
                margin-bottom: 8px;
            }

            > p {
                margin-top: 27.5px;
            }
        }

        .inquiryBtn {
            width: 318px;
            height: 46px;
            border-radius: 10px;
            border: 1px solid #ffffff;
            padding: 0 8px;

            p {
                font-size: 13px;
            }

            > div {
                gap: 8px;
            }

            svg {
                width: 24px;
                height: 24px;
            }
        }
    }

    @media (max-width: 767px) {
        p {
            font-size: 3.6107vw;
            word-break: keep-all;
        }

        padding: 10.1393vw 5.556vw 10.2083vw;

        > div {
            width: 88.8893vw;
            flex-direction: column;
            align-items: flex-start;
            gap: 2.2227vw;
        }

        .footerAd {
            order: 2;

            > div {
                gap: 2.2227vw;

                svg {
                    width: 6.6667vw;
                    height: 6.6667vw;
                }
            }

            > div:nth-child(1),
            > div:nth-child(2) {
                margin-bottom: 2.2227vw;
            }

            > p {
                margin-top: 1.944vw;
            }
        }

        .footerIq {
            order: 1;

            .inquiryBtn {
                width: 88.8893vw;
                height: 13.3333vw;
                border-radius: 2.7773vw;
                padding: 0 2.2227vw;

                p {
                    font-size: 3.6107vw;
                }

                > div {
                    gap: 2.2227vw;
                }

                svg {
                    width: 6.6667vw;
                    height: 6.6667vw;
                }
            }
        }
    }
`;

export const AndroidDownloadBtn = (props: any) => {
    const { onClick } = props;

    return (
        <svg
            onClick={onClick}
            style={{ cursor: 'pointer' }}
            width="135"
            height="48"
            viewBox="0 0 135 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="135" height="48" rx="24" fill="#292929" />
            <g clipPath="url(#clip0_2387_16467)">
                <path
                    d="M33.6 21.48L35.44 18.3C35.6 17.99 35.48 17.61 35.18 17.45C34.89 17.3 34.53 17.39 34.35 17.67L32.47 20.91C29.61 19.7 26.39 19.7 23.53 20.91L21.65 17.67C21.46 17.38 21.07 17.29 20.78 17.47C20.5 17.65 20.41 18.01 20.56 18.3L22.4 21.48C19.3 23.25 17.28 26.44 17 30H39C38.72 26.44 36.7 23.25 33.6 21.48ZM23 27.25C22.31 27.25 21.75 26.69 21.75 26C21.75 25.31 22.31 24.75 23 24.75C23.69 24.75 24.25 25.31 24.25 26C24.25 26.69 23.69 27.25 23 27.25ZM33 27.25C32.31 27.25 31.75 26.69 31.75 26C31.75 25.31 32.31 24.75 33 24.75C33.69 24.75 34.25 25.31 34.25 26C34.25 26.69 33.69 27.25 33 27.25Z"
                    fill="#65DA81"
                />
            </g>
            <path
                d="M47.928 30.5L52.194 17.162H55.344L59.61 30.5H56.802L54.912 23.552C54.708 22.856 54.51 22.136 54.318 21.392C54.138 20.636 53.946 19.904 53.742 19.196H53.67C53.502 19.916 53.316 20.648 53.112 21.392C52.92 22.136 52.728 22.856 52.536 23.552L50.628 30.5H47.928ZM50.574 27.08V25.01H56.91V27.08H50.574ZM60.9533 30.5V20.42H63.1133L63.3113 21.752H63.3653C63.8093 21.32 64.2952 20.948 64.8232 20.636C65.3513 20.324 65.9573 20.168 66.6413 20.168C67.7333 20.168 68.5253 20.528 69.0173 21.248C69.5093 21.956 69.7553 22.946 69.7553 24.218V30.5H67.1093V24.542C67.1093 23.762 66.9953 23.216 66.7673 22.904C66.5513 22.592 66.1913 22.436 65.6873 22.436C65.2793 22.436 64.9193 22.532 64.6073 22.724C64.3073 22.916 63.9713 23.198 63.5993 23.57V30.5H60.9533ZM76.0305 30.752C75.1905 30.752 74.4585 30.542 73.8345 30.122C73.2225 29.702 72.7485 29.096 72.4125 28.304C72.0765 27.512 71.9085 26.564 71.9085 25.46C71.9085 24.368 72.1065 23.432 72.5025 22.652C72.9105 21.86 73.4385 21.248 74.0865 20.816C74.7345 20.384 75.4185 20.168 76.1385 20.168C76.7025 20.168 77.1765 20.27 77.5605 20.474C77.9565 20.666 78.3345 20.93 78.6945 21.266L78.6045 19.682V16.136H81.2505V30.5H79.0905L78.8925 29.456H78.8205C78.4485 29.816 78.0225 30.122 77.5425 30.374C77.0625 30.626 76.5585 30.752 76.0305 30.752ZM76.7145 28.574C77.0745 28.574 77.4045 28.496 77.7045 28.34C78.0165 28.172 78.3165 27.902 78.6045 27.53V23.102C78.3045 22.826 77.9925 22.634 77.6685 22.526C77.3565 22.406 77.0385 22.346 76.7145 22.346C76.3425 22.346 75.9945 22.466 75.6705 22.706C75.3585 22.934 75.1065 23.276 74.9145 23.732C74.7225 24.188 74.6265 24.752 74.6265 25.424C74.6265 26.12 74.7045 26.702 74.8605 27.17C75.0285 27.638 75.2685 27.992 75.5805 28.232C75.8925 28.46 76.2705 28.574 76.7145 28.574ZM84.0685 30.5V20.42H86.2285L86.4265 22.202H86.4805C86.8525 21.542 87.2905 21.038 87.7945 20.69C88.2985 20.342 88.8145 20.168 89.3425 20.168C89.6305 20.168 89.8585 20.192 90.0265 20.24C90.2065 20.276 90.3685 20.324 90.5125 20.384L90.0805 22.67C89.8885 22.622 89.7145 22.586 89.5585 22.562C89.4145 22.526 89.2285 22.508 89.0005 22.508C88.6165 22.508 88.2085 22.658 87.7765 22.958C87.3565 23.258 87.0025 23.768 86.7145 24.488V30.5H84.0685ZM95.8391 30.752C94.9991 30.752 94.2071 30.542 93.4631 30.122C92.7311 29.702 92.1371 29.102 91.6811 28.322C91.2251 27.53 90.9971 26.576 90.9971 25.46C90.9971 24.344 91.2251 23.396 91.6811 22.616C92.1371 21.824 92.7311 21.218 93.4631 20.798C94.2071 20.378 94.9991 20.168 95.8391 20.168C96.4751 20.168 97.0811 20.288 97.6571 20.528C98.2331 20.768 98.7491 21.116 99.2051 21.572C99.6611 22.016 100.021 22.568 100.285 23.228C100.549 23.876 100.681 24.62 100.681 25.46C100.681 26.576 100.453 27.53 99.9971 28.322C99.5411 29.102 98.9411 29.702 98.1971 30.122C97.4651 30.542 96.6791 30.752 95.8391 30.752ZM95.8391 28.592C96.2951 28.592 96.6791 28.466 96.9911 28.214C97.3151 27.95 97.5551 27.584 97.7111 27.116C97.8791 26.648 97.9631 26.096 97.9631 25.46C97.9631 24.824 97.8791 24.272 97.7111 23.804C97.5551 23.336 97.3151 22.976 96.9911 22.724C96.6791 22.46 96.2951 22.328 95.8391 22.328C95.3831 22.328 94.9931 22.46 94.6691 22.724C94.3571 22.976 94.1171 23.336 93.9491 23.804C93.7931 24.272 93.7151 24.824 93.7151 25.46C93.7151 26.096 93.7931 26.648 93.9491 27.116C94.1171 27.584 94.3571 27.95 94.6691 28.214C94.9931 28.466 95.3831 28.592 95.8391 28.592ZM102.895 30.5V20.42H105.541V30.5H102.895ZM104.227 18.782C103.759 18.782 103.387 18.656 103.111 18.404C102.835 18.14 102.697 17.786 102.697 17.342C102.697 16.91 102.835 16.562 103.111 16.298C103.387 16.034 103.759 15.902 104.227 15.902C104.671 15.902 105.037 16.034 105.325 16.298C105.613 16.562 105.757 16.91 105.757 17.342C105.757 17.786 105.613 18.14 105.325 18.404C105.037 18.656 104.671 18.782 104.227 18.782ZM111.907 30.752C111.067 30.752 110.335 30.542 109.711 30.122C109.099 29.702 108.625 29.096 108.289 28.304C107.953 27.512 107.785 26.564 107.785 25.46C107.785 24.368 107.983 23.432 108.379 22.652C108.787 21.86 109.315 21.248 109.963 20.816C110.611 20.384 111.295 20.168 112.015 20.168C112.579 20.168 113.053 20.27 113.437 20.474C113.833 20.666 114.211 20.93 114.571 21.266L114.481 19.682V16.136H117.127V30.5H114.967L114.769 29.456H114.697C114.325 29.816 113.899 30.122 113.419 30.374C112.939 30.626 112.435 30.752 111.907 30.752ZM112.591 28.574C112.951 28.574 113.281 28.496 113.581 28.34C113.893 28.172 114.193 27.902 114.481 27.53V23.102C114.181 22.826 113.869 22.634 113.545 22.526C113.233 22.406 112.915 22.346 112.591 22.346C112.219 22.346 111.871 22.466 111.547 22.706C111.235 22.934 110.983 23.276 110.791 23.732C110.599 24.188 110.503 24.752 110.503 25.424C110.503 26.12 110.581 26.702 110.737 27.17C110.905 27.638 111.145 27.992 111.457 28.232C111.769 28.46 112.147 28.574 112.591 28.574Z"
                fill="white"
            />
            <defs>
                <clipPath id="clip0_2387_16467">
                    <rect width="24" height="24" fill="white" transform="translate(16 12)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const WindowDownloadBtn = (props: any) => {
    const { onClick } = props;

    return (
        <svg
            onClick={onClick}
            style={{ cursor: 'pointer' }}
            width="145"
            height="48"
            viewBox="0 0 145 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="145" height="48" rx="24" fill="#292929" />
            <g clipPath="url(#clip0_2387_16483)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20 15H36C37.1 15 38 15.9 38 17V27C38 28.1 37.1 29 36 29H30V31H32V33H24V31H26V29H20C18.9 29 18 28.1 18 27V17C18 15.9 18.9 15 20 15ZM21 17C20.4477 17 20 17.4477 20 18V26C20 26.5523 20.4477 27 21 27H35C35.5523 27 36 26.5523 36 26V18C36 17.4477 35.5523 17 35 17H21Z"
                    fill="white"
                />
            </g>
            <path
                d="M50.898 30.5L48.342 17.162H51.06L52.086 23.678C52.206 24.374 52.314 25.076 52.41 25.784C52.518 26.492 52.62 27.206 52.716 27.926H52.788C52.932 27.206 53.076 26.492 53.22 25.784C53.364 25.076 53.502 24.374 53.634 23.678L55.164 17.162H57.45L58.998 23.678C59.142 24.362 59.28 25.064 59.412 25.784C59.556 26.492 59.7 27.206 59.844 27.926H59.934C60.03 27.206 60.126 26.492 60.222 25.784C60.33 25.076 60.432 24.374 60.528 23.678L61.59 17.162H64.11L61.644 30.5H58.332L56.838 23.894C56.73 23.378 56.628 22.868 56.532 22.364C56.436 21.848 56.352 21.338 56.28 20.834H56.208C56.112 21.338 56.01 21.848 55.902 22.364C55.806 22.868 55.71 23.378 55.614 23.894L54.156 30.5H50.898ZM65.8927 30.5V20.42H68.5387V30.5H65.8927ZM67.2247 18.782C66.7567 18.782 66.3847 18.656 66.1087 18.404C65.8327 18.14 65.6947 17.786 65.6947 17.342C65.6947 16.91 65.8327 16.562 66.1087 16.298C66.3847 16.034 66.7567 15.902 67.2247 15.902C67.6687 15.902 68.0347 16.034 68.3227 16.298C68.6107 16.562 68.7547 16.91 68.7547 17.342C68.7547 17.786 68.6107 18.14 68.3227 18.404C68.0347 18.656 67.6687 18.782 67.2247 18.782ZM71.3595 30.5V20.42H73.5195L73.7175 21.752H73.7715C74.2155 21.32 74.7015 20.948 75.2295 20.636C75.7575 20.324 76.3635 20.168 77.0475 20.168C78.1395 20.168 78.9315 20.528 79.4235 21.248C79.9155 21.956 80.1615 22.946 80.1615 24.218V30.5H77.5155V24.542C77.5155 23.762 77.4015 23.216 77.1735 22.904C76.9575 22.592 76.5975 22.436 76.0935 22.436C75.6855 22.436 75.3255 22.532 75.0135 22.724C74.7135 22.916 74.3775 23.198 74.0055 23.57V30.5H71.3595ZM86.4368 30.752C85.5968 30.752 84.8648 30.542 84.2408 30.122C83.6288 29.702 83.1548 29.096 82.8188 28.304C82.4828 27.512 82.3148 26.564 82.3148 25.46C82.3148 24.368 82.5128 23.432 82.9088 22.652C83.3168 21.86 83.8448 21.248 84.4928 20.816C85.1408 20.384 85.8248 20.168 86.5448 20.168C87.1088 20.168 87.5828 20.27 87.9668 20.474C88.3628 20.666 88.7408 20.93 89.1008 21.266L89.0108 19.682V16.136H91.6568V30.5H89.4968L89.2988 29.456H89.2268C88.8548 29.816 88.4288 30.122 87.9488 30.374C87.4688 30.626 86.9648 30.752 86.4368 30.752ZM87.1208 28.574C87.4808 28.574 87.8108 28.496 88.1108 28.34C88.4228 28.172 88.7228 27.902 89.0108 27.53V23.102C88.7108 22.826 88.3988 22.634 88.0748 22.526C87.7628 22.406 87.4448 22.346 87.1208 22.346C86.7488 22.346 86.4008 22.466 86.0768 22.706C85.7648 22.934 85.5128 23.276 85.3208 23.732C85.1288 24.188 85.0328 24.752 85.0328 25.424C85.0328 26.12 85.1108 26.702 85.2668 27.17C85.4348 27.638 85.6748 27.992 85.9868 28.232C86.2988 28.46 86.6768 28.574 87.1208 28.574ZM98.6867 30.752C97.8467 30.752 97.0547 30.542 96.3107 30.122C95.5787 29.702 94.9847 29.102 94.5287 28.322C94.0727 27.53 93.8447 26.576 93.8447 25.46C93.8447 24.344 94.0727 23.396 94.5287 22.616C94.9847 21.824 95.5787 21.218 96.3107 20.798C97.0547 20.378 97.8467 20.168 98.6867 20.168C99.3227 20.168 99.9287 20.288 100.505 20.528C101.081 20.768 101.597 21.116 102.053 21.572C102.509 22.016 102.869 22.568 103.133 23.228C103.397 23.876 103.529 24.62 103.529 25.46C103.529 26.576 103.301 27.53 102.845 28.322C102.389 29.102 101.789 29.702 101.045 30.122C100.313 30.542 99.5267 30.752 98.6867 30.752ZM98.6867 28.592C99.1427 28.592 99.5267 28.466 99.8387 28.214C100.163 27.95 100.403 27.584 100.559 27.116C100.727 26.648 100.811 26.096 100.811 25.46C100.811 24.824 100.727 24.272 100.559 23.804C100.403 23.336 100.163 22.976 99.8387 22.724C99.5267 22.46 99.1427 22.328 98.6867 22.328C98.2307 22.328 97.8407 22.46 97.5167 22.724C97.2047 22.976 96.9647 23.336 96.7967 23.804C96.6407 24.272 96.5627 24.824 96.5627 25.46C96.5627 26.096 96.6407 26.648 96.7967 27.116C96.9647 27.584 97.2047 27.95 97.5167 28.214C97.8407 28.466 98.2307 28.592 98.6867 28.592ZM107.17 30.5L104.578 20.42H107.206L108.322 25.388C108.406 25.892 108.484 26.384 108.556 26.864C108.628 27.344 108.706 27.836 108.79 28.34H108.88C108.988 27.836 109.09 27.344 109.186 26.864C109.282 26.372 109.39 25.88 109.51 25.388L110.734 20.42H113.074L114.334 25.388C114.454 25.892 114.562 26.384 114.658 26.864C114.754 27.344 114.862 27.836 114.982 28.34H115.054C115.15 27.836 115.234 27.344 115.306 26.864C115.39 26.384 115.48 25.892 115.576 25.388L116.638 20.42H119.104L116.62 30.5H113.506L112.444 26.108C112.336 25.628 112.234 25.154 112.138 24.686C112.054 24.206 111.958 23.696 111.85 23.156H111.76C111.676 23.696 111.592 24.206 111.508 24.686C111.424 25.166 111.328 25.64 111.22 26.108L110.194 30.5H107.17ZM123.915 30.752C123.243 30.752 122.559 30.62 121.863 30.356C121.179 30.092 120.585 29.756 120.081 29.348L121.287 27.674C121.731 28.01 122.169 28.28 122.601 28.484C123.045 28.676 123.507 28.772 123.987 28.772C124.491 28.772 124.857 28.676 125.085 28.484C125.325 28.28 125.445 28.022 125.445 27.71C125.445 27.458 125.343 27.248 125.139 27.08C124.935 26.9 124.671 26.744 124.347 26.612C124.023 26.468 123.687 26.33 123.339 26.198C122.919 26.03 122.499 25.826 122.079 25.586C121.671 25.346 121.329 25.04 121.053 24.668C120.777 24.284 120.639 23.81 120.639 23.246C120.639 22.646 120.795 22.118 121.107 21.662C121.419 21.194 121.851 20.828 122.403 20.564C122.967 20.3 123.633 20.168 124.401 20.168C125.133 20.168 125.781 20.294 126.345 20.546C126.921 20.798 127.413 21.086 127.821 21.41L126.633 23.012C126.273 22.748 125.913 22.538 125.553 22.382C125.205 22.226 124.845 22.148 124.473 22.148C124.005 22.148 123.663 22.238 123.447 22.418C123.231 22.598 123.123 22.832 123.123 23.12C123.123 23.36 123.213 23.564 123.393 23.732C123.573 23.888 123.819 24.026 124.131 24.146C124.443 24.266 124.773 24.392 125.121 24.524C125.457 24.644 125.787 24.788 126.111 24.956C126.447 25.112 126.753 25.304 127.029 25.532C127.305 25.76 127.521 26.042 127.677 26.378C127.845 26.702 127.929 27.098 127.929 27.566C127.929 28.154 127.773 28.694 127.461 29.186C127.161 29.666 126.711 30.05 126.111 30.338C125.523 30.614 124.791 30.752 123.915 30.752Z"
                fill="white"
            />
            <defs>
                <clipPath id="clip0_2387_16483">
                    <rect width="24" height="24" fill="white" transform="translate(16 12)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const SwiperPrevBtn = () => {
    return (
        <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                width="50"
                height="50"
                rx="25"
                transform="matrix(4.37114e-08 1 1 -4.37114e-08 0 0)"
                fill="#232323"
            />
            <path d="M30 16L20 25.5L30 35" stroke="white" strokeWidth="3" />
        </svg>
    );
};

export const SwiperNextBtn = () => {
    return (
        <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="50"
                width="50"
                height="50"
                rx="25"
                transform="rotate(90 50 0)"
                fill="#232323"
            />
            <path d="M20 16L30 25.5L20 35" stroke="white" strokeWidth="3" />
        </svg>
    );
};

export const SwiperPlusIcon = () => {
    return (
        <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="48" height="48" rx="24" fill="black" fillOpacity="0.5" />
            <g clipPath="url(#clip0_2440_6805)">
                <rect
                    x="31"
                    y="23"
                    width="2"
                    height="14"
                    transform="rotate(90 31 23)"
                    fill="white"
                />
                <rect x="23" y="17" width="2" height="14" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_2440_6805">
                    <rect width="24" height="24" fill="white" transform="translate(12 12)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const ModalCloseBtn = () => {
    return (
        <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_2423_196337)">
                <g filter="url(#filter0_b_2423_196337)">
                    <rect width="48" height="48" rx="24" fill="#292929" />
                </g>
                <g clipPath="url(#clip1_2423_196337)">
                    <path
                        d="M33.0007 16.8129L31.1879 15L24.0007 22.1871L16.8136 15L15.0007 16.8129L22.1879 24L15.0007 31.1871L16.8136 33L24.0007 25.8129L31.1879 33L33.0007 31.1871L25.8136 24L33.0007 16.8129Z"
                        fill="white"
                    />
                </g>
            </g>
            <defs>
                <filter
                    id="filter0_b_2423_196337"
                    x="-3.42857"
                    y="-3.42857"
                    width="54.8571"
                    height="54.8571"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="1.71429" />
                    <feComposite
                        in2="SourceAlpha"
                        operator="in"
                        result="effect1_backgroundBlur_2423_196337"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_backgroundBlur_2423_196337"
                        result="shape"
                    />
                </filter>
                <clipPath id="clip0_2423_196337">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
                <clipPath id="clip1_2423_196337">
                    <rect
                        width="30.8571"
                        height="30.8571"
                        fill="white"
                        transform="translate(8.57227 8.57153)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const PinIco = () => {
    return (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_2387_16356)">
                <path
                    d="M12 3.5C8.40643 3.5 5.5 6.317 5.5 9.8C5.5 14.525 12 21.5 12 21.5C12 21.5 18.5 14.525 18.5 9.8C18.5 6.317 15.5936 3.5 12 3.5ZM7.35714 9.8C7.35714 7.316 9.43714 5.3 12 5.3C14.5629 5.3 16.6429 7.316 16.6429 9.8C16.6429 12.392 13.9686 16.271 12 18.692C10.0686 16.289 7.35714 12.365 7.35714 9.8Z"
                    fill="white"
                />
                <path
                    d="M12 12.0498C13.2426 12.0498 14.25 11.0424 14.25 9.7998C14.25 8.55716 13.2426 7.5498 12 7.5498C10.7574 7.5498 9.75 8.55716 9.75 9.7998C9.75 11.0424 10.7574 12.0498 12 12.0498Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_2387_16356">
                    <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const CallIco = () => {
    return (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_2387_16357)">
                <g clipPath="url(#clip1_2387_16357)">
                    <path
                        d="M15.9951 20.5002C15.2204 20.4298 14.5509 20.2526 13.897 20.0116C12.3363 19.4358 10.9515 18.561 9.67071 17.5133C7.88418 16.052 6.39224 14.3388 5.26294 12.322C4.67711 11.2753 4.23673 10.172 4.02989 8.98195C3.96717 8.62071 3.99653 8.29846 4.1967 7.98055C4.93266 6.81287 5.78038 5.74149 6.84329 4.85073C6.91102 4.79375 6.98742 4.74676 7.05981 4.69544C7.47717 4.39985 7.80978 4.45117 8.24783 4.77509C8.32689 4.8334 8.39662 4.91105 8.45367 4.99169C9.13792 5.95743 9.79581 6.94017 10.3146 8.00721C10.428 8.24048 10.5138 8.48841 10.5958 8.73501C10.6966 9.03893 10.6359 9.33019 10.4197 9.55779C10.1605 9.83105 9.87622 10.0813 9.59231 10.3296C9.22566 10.6502 9.21665 10.6468 9.41149 11.1017C10.2435 13.0428 11.6454 14.3961 13.6144 15.1676C13.7869 15.2353 13.8956 15.2306 14.0204 15.0713C14.2526 14.7744 14.5095 14.4955 14.7651 14.2175C15.0983 13.8546 15.509 13.742 15.9591 13.9499C16.5276 14.2125 17.0964 14.4818 17.6342 14.8004C18.2691 15.1763 18.8736 15.6042 19.4864 16.0167C19.7453 16.191 19.9014 16.4409 19.9775 16.7455C20.0192 16.9125 20.0062 17.0694 19.9211 17.2114C19.8104 17.3963 19.6999 17.5869 19.5585 17.7479C18.644 18.786 17.5838 19.6501 16.3861 20.3435C16.246 20.4245 16.0832 20.4665 15.9954 20.5012L15.9951 20.5002Z"
                        fill="white"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_2387_16357">
                    <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                </clipPath>
                <clipPath id="clip1_2387_16357">
                    <rect width="16" height="16" fill="white" transform="translate(4 4.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const MailIco = () => {
    return (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_2387_16355)">
                <path
                    d="M20 4.5H4C2.9 4.5 2.01 5.4 2.01 6.5L2 18.5C2 19.6 2.9 20.5 4 20.5H20C21.1 20.5 22 19.6 22 18.5V6.5C22 5.4 21.1 4.5 20 4.5ZM20 18.5H4V8.5L12 13.5L20 8.5V18.5ZM12 11.5L4 6.5H20L12 11.5Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_2387_16355">
                    <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const InquiryIco = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_2489_28682)">
                <circle cx="12" cy="12" r="8" stroke="white" strokeWidth="2" />
                <path
                    d="M11.2166 14V7.82996H12.7866V14H11.2166ZM11.2166 16.31V14.84H12.7866V16.31H11.2166Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_2489_28682">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const ArrowIco = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_2489_28684)">
                <path
                    d="M10.5691 19L17.375 12L10.5691 5L8.625 6.9996L13.4867 12L8.62638 17.0004L10.5678 19L10.5691 19Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_2489_28684">
                    <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="matrix(1 1.74846e-07 1.74846e-07 -1 0 24)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
